import { gql } from '@apollo/client'

export const GET_MY_FANTASY_LEAGUES = gql`
  query GetMyFantasyLeagues {
    userAccount {
      id
      fantasyLeagueMembers {
        id
        unreadEventsCount
        unreadMessagesCount
        unreadActivityCount
        fantasyLeague {
          id
          name
          isPublic
          participantsCount
          image
          updatedAt
          creator {
            id
            fullName
          }
        }
      }
    }
  }
`
